export default __webpack_public_path__ + "static/media/tour-5.c97671c7.jpeg";